module.exports = __webpack_public_path__ + "img/Order.a9d60abc.svg";